/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_PaidInputs */

const en_admin_funnel_footnote_paid = /** @type {(inputs: Admin_Funnel_Footnote_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payers / revenue come from the order table (status = paid, by paid_at), so webhook-only payments count. Source/country use the payer's earliest event, build uses their latest checkout; payers with no events show as unknown. Revenue sums order amounts with no currency conversion.`)
};

/**
* | output |
* | --- |
* | "Payers / revenue come from the order table (status = paid, by paid_at), so webhook-only payments count. Source/country use the payer's earliest event, build ..." |
*
* @param {Admin_Funnel_Footnote_PaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_paid = /** @type {((inputs?: Admin_Funnel_Footnote_PaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_PaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_paid(inputs)
});
export { admin_funnel_footnote_paid as "admin.funnel.footnote.paid" }